import NotificationActions from 'client/js/main/actions/NotificationActions';
import dash_api from 'client/js/main/support/dash_api';
import { ReduxAsyncAction } from 'client/js/redux/services/ReduxAsyncAction';
import type { Action } from 'redux';
import type { FileIngestionJob } from '../../../../../../shared/types/roi-hub/fileIngestion.types';

const GetJobById = new ReduxAsyncAction<'FILE_INGESTOR_GET_JOB_BY_ID', string, FileIngestionJob>(
  'FILE_INGESTOR_GET_JOB_BY_ID'
);

GetJobById.registerRequest(async (id) => {
  try {
    const result = await dash_api.get<FileIngestionJob>(`/v1/roi/file-ingestor/job/${id}`);
    return result.data;
  } catch (error) {
    NotificationActions.showNotification('Error occurred while fetching the job', 'error');
    throw error;
  }
});

export const GET_JOB_BY_ID = GetJobById.actionNamespaceConstants;

export const getJobById = GetJobById.request;

export type GetJobByIdRequestAction = Action<typeof GET_JOB_BY_ID.request>;

export type GetJobByIdResponseAction = Action<typeof GET_JOB_BY_ID.response> & { data: FileIngestionJob };
